import React from 'react'
import styled from '@emotion/styled'
import { colors, styles } from 'Constants'

// Components
import { Flex } from 'lese'

const AuthCard = styled(Flex)`
  border-radius: ${styles.borderRadius};
  padding: 32px;
  background-color: ${colors.background};
  text-align: center;
  max-width: 350px;
`
AuthCard.defaultProps = { column: true, relative: true, separation: '24px' }

export default AuthCard
